import React, { useEffect, useRef, useState } from 'react';
import { Col, Input, Row, Spin, Tag, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import * as SERVICE from '../../constants/service.types';
import * as ACTIONS from '../../redux/actions';
import { socketEmitEvent } from '../../redux/actions';
import { NOTIFIES } from '../../constants/system.keys';
import dot from '../../assets/icons/dot-icon.svg';

const LinkTag = ({ value, onChange, gatewaySerial, namespace, disabled, nameAdd, dataSubSources }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const refSaveInput = useRef(null);
  const refSaveEditInput = useRef(null);
  const refHandleTimer = useRef();
  const { checkRtspStreamReturn } = useSelector((state) => state);
  const [handleTimer, setHandleTimer] = useState();
  const [tags, setTags] = useState([]);
  const [inputVisible, setInputVisible] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [editInputIndex, setEditInputIndex] = useState(-1);
  const [editInputValue, setEditInputValue] = useState('');
  const [requestCheckRtsp, setRequestCheckRtsp] = useState(0);
  const [inputValueTemp, setInputValueTemp] = useState('');

  useEffect(() => {
    if (value && value !== tags) {
      setTags(value)
    }
  }, [value]);

  useEffect(() => {
    if (checkRtspStreamReturn?.requestId === requestCheckRtsp) {
      clearInterval(refHandleTimer.current);
      setHandleTimer(null);
      if (checkRtspStreamReturn?.result === 1 && checkRtspStreamReturn?.data?.[0]?.authenticationRtsp === 'ok') {
        const tagsTemp = tags?.find(item => item === inputValueTemp) ? [...tags] : [...tags, inputValueTemp]
        onChange(tagsTemp)
        setTags(tagsTemp)
        setInputVisible(false)
        setInputValue('')
        ACTIONS.openMessage(NOTIFIES.SUCCESS, t('Add sourse successful!'));
      } else {
        ACTIONS.openMessage(NOTIFIES.WARNING, t('Device not found, check again!'));
      }
    }
  }, [checkRtspStreamReturn]);

  useEffect(() => {
    if (handleTimer <= 0) {
      clearInterval(refHandleTimer.current);
      setHandleTimer(null);
      ACTIONS.openMessage(NOTIFIES.WARNING, t('Timeout, can not find video source stream!'));
    }
  }, [handleTimer, t]);

  useEffect(() => {
    if (refSaveInput.current && inputVisible) {
      refSaveInput.current.input.focus()
    }
  }, [refSaveInput, inputVisible]);

  const handleClose = removedTag => {
    const tagsTemp = tags.filter(tag => tag !== removedTag);
    onChange(tagsTemp)
    setTags(tagsTemp)
  };

  const showInput = () => {
    setInputVisible(true)
  };

  const handleInputChange = e => {
    setInputValue(e.target.value)
  };

  const handleInputConfirm = () => {
    if (inputValue && tags.indexOf(inputValue) === -1) {
      if (!(handleTimer && handleTimer > 0)) {
        const requestId = new Date().getTime()
        setRequestCheckRtsp(requestId)
        setHandleTimer(10);
        refHandleTimer.current = setInterval(() => {
          setHandleTimer((timer) => timer - 1);
        }, 1000);
        let data = {
          source: inputValue,
          namespace,
          gatewaySerial
        };
        let dataObj = {
          appServiceType: SERVICE.CHECK_RTSP_STREAM,
          requestId,
          body: JSON.stringify(data),
        };
        setInputValueTemp(inputValue)
        dispatch(socketEmitEvent(dataObj));
      }
    } else {
      setInputVisible(false)
      setInputValue('')
    }
  };

  const handleEditInputChange = e => {
    setEditInputValue(e.target.value)
  };

  const handleEditInputConfirm = () => {
    let newTags = [...tags];
    newTags[editInputIndex] = editInputValue;
    onChange(newTags)
    setTags(newTags)
    setEditInputIndex(-1)
    setEditInputValue('')
  };
  return (
    <div style={{ width: "96%", margin: '4px 0px 3px 10px' }}>
      {tags && tags.length > 0 && tags.map((tag, index) => {
        if (editInputIndex === index) {
          return (
            <Input
              ref={refSaveEditInput}
              key={tag}
              size="small"
              style={{ width: '200px', marginRight: '8px', verticalAlign: 'top' }}
              value={editInputValue}
              onChange={handleEditInputChange}
              onBlur={handleEditInputConfirm}
              onPressEnter={handleEditInputConfirm}
            />
          );
        }

        const isLongTag = tag.length > 20;

        const tagElem = (
          <Tag
            style={{ userSelect: 'none', marginBottom: "3px" }}
            key={tag}
            closable={!disabled}
            onClose={() => handleClose(tag)}
          >
            <span>
              {isLongTag ? `${tag.slice(0, 20)}...` : tag}
            </span>
          </Tag>
        );
        const checkDataSource = dataSubSources?.find(item => item.zoomState && item.resolution && (item.source === tag))
        return isLongTag ? (
          <Tooltip
            title={
              <Row>
                <Col span={24} style={{ display: 'flex' }}>
                  <img style={{ width: '4px', marginRight: "5px", alignSelf: 'end', marginTop: '9px' }} src={dot} alt="next-page" />
                  <div style={{ width: "98%" }}>{checkDataSource?.source ?? tag}</div>
                </Col>
                {checkDataSource?.zoomState && <Col span={24}>
                  <img style={{ width: '4px', marginRight: "5px" }} src={dot} alt="next-page" />
                  Zoom state: {checkDataSource?.zoomState}
                </Col>}
                {checkDataSource?.resolution && <Col span={24}>
                  <img style={{ width: '4px', marginRight: "5px" }} src={dot} alt="next-page" />
                  Resolution: {checkDataSource?.resolution}p
                </Col>}
              </Row>
            }
            key={tag}>
            {tagElem}
          </Tooltip>
        ) : (
          tagElem
        );
      })}
      {inputVisible && (
        <Input
          prefix={(handleTimer && handleTimer > 0) && <Spin indicator={<LoadingOutlined style={{ fontSize: 12, color: '#0e9347', marginTop: '-4px' }} />} />}
          disabled={handleTimer && handleTimer > 0}
          ref={refSaveInput}
          type="text"
          size="small"
          style={{ width: '200px', marginRight: '8px', verticalAlign: 'top' }}
          value={inputValue}
          onChange={handleInputChange}
          onBlur={handleInputConfirm}
          onPressEnter={handleInputConfirm}
        />
      )}
      {!inputVisible && !disabled && tags?.length < 4 && (
        <Tag style={{ borderStyle: 'dashed', cursor: "pointer" }} onClick={showInput}>
          <PlusOutlined /> {nameAdd}
        </Tag>
      )}
    </div>
  );
}
export default LinkTag;